const trackerRules = {
  refunds: {
    whitelistedPaths: ['/search', 'contactUs'],
  },
};

export default trackerRules;
